import { Alert as ANTAlert } from "antd";
import styled from "styled-components";
import { themeProp } from "../theme";

const Alert = styled(ANTAlert)`
  &.ant-alert {
    border-radius: 8px;
    border: 1px solid #ffccc7;
    background: #fff2f0;
  }

  & .ant-alert-content {
    text-align: left;
    font-size: ${themeProp(`typography.body.fontSize`)} !important;
    font-family: ${themeProp(`typography.body.fontFamily`)} !important;
    font-weight: ${themeProp(`typography.body.fontWeight`)} !important;
    line-height: ${themeProp(`typography.body.lineHeight`)} !important;
  }

  & .ant-alert-message {
    font-weight: 700;
  }
`;

export default Alert;
